import { ApiService } from 'networking/api-service';
import { API_ROUTES } from 'networking/api-routes';

// Raw shapes from the Rails iCloud Shared Album proxy
// (Api::IcloudSharedAlbumsController).

export type IcloudDerivativeRaw = {
  key: string;
  checksum: string;
  file_size: number;
  width: number;
  height: number;
};

export type IcloudPhotoRaw = {
  photo_guid: string;
  caption: string | null;
  date_created: string | null;
  batch_date_created: string | null;
  media_asset_type: 'photo' | 'video' | string;
  derivatives: IcloudDerivativeRaw[];
};

export type IcloudStreamRaw = {
  host: string;
  stream_name: string;
  owner_name: string | null;
  photos: IcloudPhotoRaw[];
};

class IcloudController {
  static async getStream(token: string): Promise<IcloudStreamRaw> {
    const response = await ApiService.post<IcloudStreamRaw>(
      API_ROUTES.ICLOUD_STREAM,
      { token },
    );
    return response.data;
  }

  static async getAssetUrls(
    token: string,
    host: string,
    photoGuids: string[],
  ): Promise<Record<string, string>> {
    const response = await ApiService.post<{ urls: Record<string, string> }>(
      API_ROUTES.ICLOUD_ASSET_URLS,
      { token, host, photo_guids: photoGuids },
    );
    return response.data.urls ?? {};
  }
}

export { IcloudController };
